module.exports = __webpack_public_path__ + "img/fitbit-sidebar.e3e3e8f1.svg";